<template>
  <div class="mainDiv">
    <el-tabs
      v-model="reviewStatus"
      type="card"
      @tab-click="handleReviewStatusChange"
    >
      <el-tab-pane
        v-for="item in roleType !=60?reviewStatusList:reviewStatusList1"
        :key="item.value"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>

    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item prop="majorName" label="班级专业：">
                  <el-input
                    size="small"
                    clearable
                    v-model="form.majorName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="albumTitle" label="班级名称：">
                  <el-input
                    size="small"
                    v-model="form.albumTitle"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="classCode" label="班级编码：">
                  <el-input
                    size="small"
                    v-model="form.classCode"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item prop="applyType" label="报名方式：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.applyType"
                    clearable
                    placeholder="-不限-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in applyTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="classAdviserName" label="班主任：">
                  <el-input
                    size="small"
                    v-model="form.classAdviserName"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="isOvert" label="是否公开报名：">
                  <el-radio v-model="form.isOvert" label="">不限</el-radio>
                  <el-radio v-model="form.isOvert" label="0">否</el-radio>
                  <el-radio v-model="form.isOvert" label="1">是</el-radio>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item prop="signupStarttime" label="报名开始时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.signupStarttime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    clearable
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="signupEndtime" label="报名截止时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.signupEndtime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    clearable
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="year" label="年度：">
                  <el-input
                    size="small"
                    v-model="form.year"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item prop="openClassTime" label="开班时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.openClassTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    clearable
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="closeClassTime" label="结班时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.closeClassTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    clearable
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="term" label="学期：">
                  <el-select
                    ref="termListSelect"
                    v-model="form.term"
                    clearable
                    placeholder="-请选择-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in termList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="合作机构："  prop="partnerInstitution">
                  <el-select
                    size="small"
                    v-model="form.partnerInstitution"
                    clearable
                    placeholder="-请选择-"
                  >
                    <el-option
                      v-for="item in partnerInstitutionList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合作院校：" prop="partnerSchool">
                  <el-select
                    size="small"
                    v-model="form.partnerSchool"
                    clearable
                    placeholder="-请选择-"
                  >
                    <el-option
                      v-for="item in partnerSchoolList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control" v-if="!isAddClass">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button v-if="reviewStatus != 1 && roleType != 60" type="primary" @click="addClass"
          >添加班级</el-button
        >
        <el-button v-if="reviewStatus != 1 && roleType != 60" type="primary" @click="exportClass"
          >导出筛选结果</el-button
        >
        <el-button
          v-if="reviewStatus != 1 && roleType != 60"
          type="primary"
          @click="classDisable()"
          >禁用班级</el-button
        >
        <el-button v-if="reviewStatus == 2 && roleType != 60" type="primary" @click="openClass"
          >开班</el-button
        >
        <el-button v-if="reviewStatus == 0 && roleType != 60" type="primary" @click="auditPass()"
          >审核通过</el-button
        >
        <!-- <el-button v-if="reviewStatus == 0" type="primary">审核退回</el-button> -->
        <el-button @click="handleDelete" v-if="reviewStatus == 1 && roleType != 60" type="primary"
          >彻底删除</el-button
        >
        <el-button
          @click="handleEnableClassClass()"
          v-if="reviewStatus == 1 && roleType != 60"
          type="primary"
          >启用班级</el-button
        >
      </div>
    </div>

    <el-table
      v-if="!isAddClass"
      :data="tableData"
      border
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="albumTitle"
        label="班级名称"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div style="color: #409eff; cursor: pointer">
            {{ scope.row.albumTitle }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="classCode"
        label="班级编码"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="majorName"
        label="所属专业"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column label="班级封面" align="center" header-align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.url"
            :src="scope.row.url"
            width="60"
            height="60"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="partnerSchoolName"
        label="合作院校"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="partnerInstitutionName"
        label="合作机构"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="year"
        label="年级"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="term"
        label="学期"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.term == '1'">秋季学期</div>
          <div v-else-if="scope.row.term == '2'">春季学期</div>
          <div v-else-if="scope.row.term == '3'">夏季学期</div>
          <div v-else>{{ scope.row.term }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="price"
        label="价格"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="applyType"
        label="报名方式"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.applyType == '1'">先审核后缴费</div>
          <div v-if="scope.row.applyType == '2'">先缴费后审核</div>
          <div v-if="scope.row.applyType == '3'">仅审核无缴费</div>
          <div v-if="scope.row.applyType == '4'">无审核仅缴费</div>
          <div v-if="scope.row.applyType == '5'">无审核无缴费</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="isOvert"
        label="是否公开报名"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.isOvert == '0'">否</div>
          <div v-if="scope.row.isOvert == '1'">是</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="studyCount"
        label="学习人数"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="classAdviserName"
        label="班主任"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="classStatus"
        label="班级状态"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="signupStarttime"
        label="开始报名时间"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="signupEndtime"
        label="截止报名时间"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="payTime"
        label="缴费截止时间"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="openClassTime"
        label="开班时间"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="closeClassTime"
        label="结班时间"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="uname"
        label="操作"
        min-width="200"
        header-align="center"
      >
        <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              @click="
                goSingleClassManagement(scope.row.id, scope.row.albumTitle, '1')
              "
              >班级课程</span
            >
            <span class="table_control_item" @click="classInfo(scope.row)">
              | 班级信息</span
            >
            <span
              class="table_control_item"
              v-if="reviewStatus != 1 && roleType != 60"
              @click="classEdit(scope.row)"
            >
              | 编辑</span
            >
            <span
              class="table_control_item"
              v-if="reviewStatus == 2"
              @click="
                goSingleClassManagement(scope.row.id, scope.row.albumTitle, '2')
              "
            >
              | 学习管理</span
            >
            <span class="table_control_item" v-if="reviewStatus == 2 && roleType != 60">
              | 评价</span
            >

            <span
              class="table_control_item"
              v-if="reviewStatus != 1 && roleType != 60"
              @click="classDisable(scope.row.id)"
            >
              | 禁用</span
            >
            <span
              class="table_control_item"
              v-if="reviewStatus == 2 && roleType != 60"
              @click="startApply(scope.row.id)"
            >
              | 开始报名</span
            >

            <!-- <span class="table_control_item" v-if="reviewStatus == 0" >提交审核  |</span> -->
            <span
              class="table_control_item"
              v-if="reviewStatus == 0 && roleType != 60"
              @click="auditPass(scope.row.id)"
            >
              | 审核通过</span
            >
            <!-- <span class="table_control_item" v-if="reviewStatus == 0" >| 审核退回</span> -->

            <span
              class="table_control_item"
              v-if="reviewStatus == 1 && roleType != 60"
              @click="handleEnableClassClass(scope.row.id)"
            >
              | 启用</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="!isAddClass"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <AddClass
      v-if="isAddClass"
      :params="params"
      :userType="userType"
      @closeAddClass="closeAddClass"
    />
  </div>
</template>

<script>
import AddClass from './addClass.vue'
import * as api from '@/api/ClassManagement/index.js'
import * as api2 from '@/api/courseware/checkCourseware'
import * as api3 from '@/api/ClassManagement/addClass.js'
export default {
  components: {
    AddClass,
  },
  data() {
    return {
      userType: '',
      reviewStatusList: [
        { value: '2', label: '已审班级', name: '2' },
        { value: '0', label: '待审班级', name: '0' },
        { value: '1', label: '回收站', name: '1' },
      ],
      reviewStatusList1: [
        { value: '2', label: '已审班级', name: '2' },
      ],
      reviewStatus: '2',
      activeNames: [],
      form: {
        majorName: '',
        albumTitle: '',
        classCode: '',
        applyType: '',
        classAdviserName: '',
        isOvert: '',
        signupStarttime: [],
        signupEndtime: [],
        year: '',
        openClassTime: [],
        closeClassTime: [],
        term: '',
        partnerInstitution: '',
        partnerSchool: '',
      },
      applyTypeList: [
        {
          value: '1',
          label: '先审核后缴费',
        },
        {
          value: '2',
          label: '先缴费后审核',
        },
        {
          value: '3',
          label: '仅审核无缴费',
        },
        {
          value: '4',
          label: '无审核仅缴费',
        },
        {
          value: '5',
          label: '无审核无缴费',
        },
      ],
      termList: [
        {
          value: '1',
          label: '秋季学期',
        },
        {
          value: '2',
          label: '春季学期',
        },
        {
          value: '3',
          label: '夏季学期',
        },
      ],
      selectedList: [],
      tableData: [],
      isAddClass: false,
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      params: null,
      partnerInstitutionList: [],
      partnerSchoolList: [],
      roleType:0 // 角色类型 为60需要隐藏的功能
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  created() {
    this.initForm = { ...this.form }
    this.getUserByUid()
    this.getElAlbumList()
    this.getPartnerInstitution()
    this.getPartnerSchool()
    this.getFindUserByUid()
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      const dateee = new Date(date).toJSON()
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    async getPartnerInstitution() {
      const { code, data } = (await api3.getPartnerInstitution()).data
      if (code === 100000) {
        this.partnerInstitutionList = data
        console.log('this.partnerInstitutionList', this.partnerInstitutionList)
      }
    },
    async getPartnerSchool() {
      const { code, data } = (await api3.getPartnerSchool()).data
      if (code === 100000) {
        this.partnerSchoolList = data
        console.log(' this.partnerSchoolList', this.partnerSchoolList, data)
      }
    },
    async getUserByUid() {
      // this.getUId
      const { code, data } = (await api2.getUserByUid(this.getUId)).data
      if (code === 100000) {
        // console.log('userType',data)
        this.userType = data.type
      }
    },
    async getFindUserByUid(){
      const { code, data } = (await api2.getFindUserByUid(this.getUId)).data
      if (code === 100000) {
        // console.log('userType222',data)
        let type = data.type.split(',');
        let flag = false;
        if(type.length>0){
          type.forEach(item=>{
             if(item==='60'){
               flag = true;
             }
          })
        }
        if(flag){
          this.roleType = 60
        }
      }
    },
    handleQueryParam() {
      const {
        majorName,
        albumTitle,
        classCode,
        applyType,
        classAdviserName,
        isOvert,
        signupStarttime,
        signupEndtime,
        year,
        openClassTime,
        closeClassTime,
        term,
        partnerSchool,
        partnerInstitution,
      } = this.form
      const [minSignupStarttime, maxSignupStarttime] = signupStarttime || [
        '',
        '',
      ]
      const [minSignupEndtime, maxSignupEndtime] = signupEndtime || ['', '']
      const [minOpenClassTime, maxOpenClassTime] = openClassTime || ['', '']
      const [minCloseClassTime, maxCloseClassTime] = closeClassTime || ['', '']
      const query = {
        majorName,
        albumTitle,
        classCode,
        applyType,
        classAdviserName,
        isOvert,
        year,
        term,
        minSignupStarttime,
        maxSignupStarttime,
        minSignupEndtime,
        maxSignupEndtime,
        minOpenClassTime,
        maxOpenClassTime,
        minCloseClassTime,
        maxCloseClassTime,
        partnerSchool,
        partnerInstitution,
      }
      return query
    },
    async getElAlbumList() {
      let query = this.handleQueryParam()
      const { code, data } = (
        await api.getElAlbumList({
          type: this.reviewStatus,
          ...query,
          uid: this.getUId,
          ...this.pageObj,
        })
      ).data
      if (code === 100000) {
        const now = Date.parse(new Date())
        this.tableData = data.list.map((item) => {
          item.signupStarttime = this.formatDate(item.signupStarttime)
          item.signupEndtime = this.formatDate(item.signupEndtime)
          item.openClassTime = this.formatDate(item.openClassTime)
          item.closeClassTime = this.formatDate(item.closeClassTime)
          item.payTime = this.formatDate(item.payTime)
          if (
            item.signupStarttime &&
            item.signupEndtime &&
            item.openClassTime &&
            item.closeClassTime
          ) {
            if (now < Date.parse(new Date(item.openClassTime))) {
              item.classStatus = '未开班'
            } else if (
              Date.parse(new Date(item.closeClassTime)) > now &&
              item.classNum < item.studyCount
            ) {
              item.classStatus = '开班中'
            } else if (
              now > Date.parse(new Date(item.closeClassTime)) &&
              item.classNum < item.studyCount
            ) {
              item.classStatus = '已结班'
            } else if (
              now > Date.parse(new Date(item.openClassTime)) &&
              item.studyCount < item.classNum
            ) {
              item.classStatus = '已停班'
            }
          } else {
            item.classStatus = ''
          }
          return { ...item }
        })
        this.total = data.total
      }
    },
    exportClass() {
      let query = this.handleQueryParam()
      window.open(
        `${this.url}/zkfz/elAlbum/exportElAlbumList?type=${this.reviewStatus}&uid=${this.getUId}&majorName=${query.majorName}&albumTitle=${query.albumTitle}&classCode=${query.classCode}&applyType=${query.applyType}&classAdviserName=${query.classAdviserName}&isOvert=${query.isOvert}&year=${query.year}&term=${query.term}&minSignupStarttime=${query.minSignupStarttime}&maxSignupStarttime=${query.maxSignupStarttime}&minSignupEndtime=${query.minSignupEndtime}&maxSignupEndtime=${query.maxSignupEndtime}&minOpenClassTime=${query.minOpenClassTime}&maxOpenClassTime=${query.maxOpenClassTime}&minCloseClassTime=${query.minCloseClassTime}&maxCloseClassTime=${query.maxCloseClassTime}&partnerSchool=${query.partnerSchool}&partnerInstitution=${query.partnerInstitution}`
      )
    },
    handleReviewStatusChange(tab) {
      this.pageObj.page = 1
      this.reviewStatus = tab.name
      this.getElAlbumList()
      if (tab.name !== '3') {
        if (this.isAddClass) {
          this.reviewStatusList.splice(3, 1)
          this.isAddClass = false
        }
      }
    },
    //搜索的折叠面板
    toggle() {
      console.log(66, this.activeNames)
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    //清空搜索内容
    delAll() {
      this.$refs.form.resetFields()
      this.form = { ...this.initForm }
      this.pageObj.page = 1
      this.getElAlbumList()
    },
    //搜索
    search() {
      this.pageObj.page = 1
      this.getElAlbumList()
    },
    addClass() {
      this.activeNames = ['1']
      this.toggle()
      this.reviewStatusList.push({ value: '3', label: '添加', name: '3' })
      this.reviewStatus = '3'
      this.params = { status: 'add' }
      this.isAddClass = true
    },
    closeAddClass() {
      this.reviewStatusList.splice(3, 1)
      this.reviewStatus = '2'
      this.isAddClass = false
      this.getElAlbumList()
    },
    classInfo(row) {
      this.activeNames = ['1']
      this.toggle()
      this.reviewStatusList.push({ value: '3', label: '班级信息', name: '3' })
      this.reviewStatus = '3'
      this.params = { row, status: 'info' }
      this.isAddClass = true
    },
    classEdit(row) {
      this.activeNames = ['1']
      this.toggle()
      this.reviewStatusList.push({ value: '3', label: '编辑', name: '3' })
      this.reviewStatus = '3'
      this.params = { row, status: 'edit' }
      this.isAddClass = true
    },
    handleConfirm(callback) {
      this.$confirm('确定要进行此操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          //点击确定的操作(调用接口)
          if (typeof callback === 'function') {
            callback()
              .then((res) => {
                if (res && res.data && res.data.code === 100000) {
                  this.$message.success('操作成功')
                  this.getElAlbumList()
                } else {
                  this.$message.error('操作失败')
                }
              })
              .catch((err) => {
                this.$message.error('系统异常')
              })
          }
        })
        .catch(() => {
          //几点取消的提示
        })
    },
    classDisable(id = null) {
      console.log('id', id)
      let ids = ''
      if (id) ids = id
      else {
        this.selectedList.forEach((item) => {
          ids += item.id + ','
        })
        let reg = /,$/gi
        ids = ids.replace(reg, '')
      }

      console.log('this.selectedList', this.selectedList, ids, id)
      if (!ids) {
        this.$message.warning('请选择要操作的课程')
        return
      }
      this.handleConfirm(api.disableClass.bind(this, { ids }))
    },
    startApply(id) {
      let ids = id
      if (!ids) {
        this.$message.warning('请选择要操作的课程')
        return
      }
      this.handleConfirm(api.startApply.bind(this, { ids }))
    },
    handleDelete() {
      let ids = ''
      this.selectedList.forEach((item) => {
        ids += item.id + ','
      })

      console.log('this.selectedList', this.selectedList, ids)
      let reg = /,$/gi
      ids = ids.replace(reg, '')
      if (!ids) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.handleConfirm(api.deleteClass.bind(this, { ids }))
    },
    handleEnableClassClass(id = null) {
      let ids = ''
      if (id) ids = id
      else {
        this.selectedList.forEach((item) => {
          ids += item.id + ','
        })
        let reg = /,$/gi
        ids = ids.replace(reg, '')
      }
      console.log('this.selectedList', this.selectedList, ids)
      if (!ids) {
        this.$message.warning('请选择要操作的数据')
        return
      }
      this.handleConfirm(api.enableClass.bind(this, { ids }))
    },
    auditPass(id = null) {
      let ids = ''
      if (id) ids = id
      else {
        this.selectedList.forEach((item) => {
          ids += item.id
        })
        let reg = /,$/gi
        ids = ids.replace(reg, '')
      }
      console.log('this.selectedList', this.selectedList, ids, id)
      if (!ids) {
        this.$message.warning('请选择要操作的课程')
        return
      }
      this.handleConfirm(api.auditClass.bind(this, { ids }))
    },
    async openClass() {
      console.log(this.selectedList)
      let ids = ''
      for (let i = 0; i < this.selectedList.length; i++) {
        if (this.selectedList[i].classStatus !== '未开班') {
          return this.$message.error('选中班级必须是未开班')
        }
        ids += this.selectedList[i].id
      }
      if (!ids) {
        this.$message.warning('请选择要操作的课程')
        return
      }
      this.handleConfirm(api.openClass.bind(this, { ids }))
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getElAlbumList()
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getElAlbumList()
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur()
        this.$refs.termListSelect.blur()
      }
    },
    goSingleClassManagement(id, albumTitle, tab) {
      this.$router.push(
        `/SingleClassManagement?id=${id}&albumTitle=${albumTitle}&tab=${tab}`
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
/deep/.el-collapse {
  padding-bottom: 20px;
}
.table_control {
  color: #409eff;
  .table_control_item {
    vertical-align: middle;
    cursor: pointer;
  }
}
</style>